import React, { Component } from "react";
import CryptoJS from "crypto-js";
import { withRouter } from "react-router-dom";
import AuthService from "../../session/AuthService";
import FarmShopConnectLogo from "../../images/FarmShopConnectLogo.png";
import LoginService from "../../api/LoginService";
import { Toaster, toast } from "react-hot-toast";
import { ContentPasteSearchOutlined } from "@mui/icons-material";
import { Col, Row } from "react-bootstrap";
import playstore from "../../images/playstore.png";
import appstore from "../../images/appstore.png";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      finalResetUpdate: false,
      formValues: {
        newPassword: "",
        confirmPassword: "",
      },
      id: 0,
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const encodedEmail = urlParams.get("id");

    console.log("encoded", encodedEmail);

    var id = 0;
    if (encodedEmail !== null) {
      id = atob(encodedEmail);
    }

    this.setState(
      {
        id: id,
      },
      () => {
        console.log("id in compontentdidmount", this.state.id);
      }
    );
  }

  render() {
    return (
      <>
        {!this.state.finalResetUpdate ? (
          <div className="login-page">
            <div className="logo-container">
              <img src={FarmShopConnectLogo} alt="Logo" className="logo" />
            </div>
            <div className="login-card">
              <h5 style={{ fontWeight: 700, color: "#292929" }}>
                New Password
              </h5>
              <p style={{ color: "#545454" }}>Enter new password:</p>
              <input
                type="password"
                placeholder="New Password"
                name="newPassword"
                onChange={this.handlechange}
                value={this.state.formValues.newPassword}
              />
              {this.state.formValues.newPassword.length > 0 &&
                this.state.formValues.newPassword.length < 5 && (
                  <div style={{ color: "red", fontSize: "15px" }}>
                    Password must be at least 5 characters long
                  </div>
                )}

              <input
                type="password"
                placeholder="Confirm Password"
                name="confirmPassword"
                onChange={this.handlechange}
                value={this.state.formValues.confirmPassword}
              />
              {this.state.formValues.confirmPassword.length > 0 &&
                this.state.formValues.confirmPassword !==
                  this.state.formValues.newPassword && (
                  <div style={{ color: "red", fontSize: "15px" }}>
                    Passwords do not match
                  </div>
                )}

              <div className="allign-button d-flex justify-content-center">
                <button
                  type="button"
                  className="btn btn-success"
                  id="successbutton"
                  onClick={this.ResetPasswordButtonclick}
                  style={{ fontFamily: "Karla" }}
                >
                  Log In
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="login-page">
            <div className="logo-container">
              <img src={FarmShopConnectLogo} alt="Logo" className="logo" />
            </div>
            <div className="login-card">
              <h5 style={{ fontWeight: 700, color: "#292929" }}>
                {`Password ${ AuthService.getStateofLoginPage() === "forgotPassword"   ? "Reset" : "Created" }  Successfully`}
              </h5>
              { AuthService.getStateofLoginPage() === "forgotPassword" ? (
                <p style={{ color: "#545454" }}>
                  You can now login with your new credentials{" "}
                </p>
              ) : (
                <Row className="p-2">
                  <Col xs={12}>
                    <p className="my-2" align="center">
                      Get the app.
                    </p>
                  </Col>
                  <Col
                    xs={6}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://apps.apple.com/in/app/farm-shop-connect/id6470219426"
                    >
                      <img
                        src={appstore}
                        alt="Download on App Store"
                        className="responsive-ref-ios"
                        loading="lazy"
                      />
                    </a>
                  </Col>
                  <Col
                    xs={6}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://play.google.com/store/apps/details?id=com.farmshopconnect.mobileapp"
                    >
                      <img
                        src={playstore}
                        alt="Download on Play Store"
                        className="responsive-ref-android"
                        loading="lazy"
                      />
                    </a>
                  </Col>
                </Row>
              )}
              <div className="allign-button d-flex justify-content-center">
                {AuthService.getStateofLoginPage() === "forgotPassword" && <button
                  type="button"
                  className="btn btn-success"
                  id="successbutton"
                  onClick={this.goToLoginPage}
                  style={{ fontFamily: "Karla" }}
                >
                  Go Log In
                </button>}
              </div>
            </div>
          </div>
        )}
        <Toaster />
      </>
    );
  }

  handlechange = (event) => {
    let form = { ...this.state.formValues };

    form[event.target.name] = event.target.value;

    this.setState(
      {
        formValues: form,
      },
      () => {
        console.log("formValue", this.state.formValues);
      }
    );
  };

  goToLoginPage = () => {
    this.props.history.replace("/login");
  };

  ResetPasswordButtonclick = () => {
    // console.log(
    //   "AuthService.getStateofLoginPage()",
    //   AuthService.getStateofLoginPage()
    // );
    // console.log("temp:",this.state.id === 0 || AuthService.getStateofLoginPage() !== "forgotPassword");
    // console.log("temp:",this.state.id === 0);
    // console.log("temp:",AuthService.getStateofLoginPage() !== "forgotPassword");

    
    if (!this.state.formValues.newPassword) {
      toast.error("Please Enter the Password");
    } else if (!this.state.formValues.confirmPassword) {
      toast.error("Please Enter the Confirm Password");
    } else if (
      this.state.formValues.newPassword !==
      this.state.formValues.confirmPassword
    ) {
      toast.error("Password Not Same");
    } else {
      console.log("AuthService.getStateofLoginPage()", this.state.id);
      if (this.state.id === 0) {
        if (
          AuthService.getStateofLoginPage() === "forgotPassword" ||
          AuthService.getStateofLoginPage() === "firstTimeUser"
        ) {
          let obj = {
            mailId: JSON.parse(AuthService.otpmailId()).mailId,
            password: CryptoJS.MD5(
              this.state.formValues.confirmPassword
            ).toString(),
          };

          console.log(obj, "password:");

          LoginService.mobilePasswordChanged(obj).then((response) => {
            console.log("response", response);
            if (response.data && response.data.status === 1) {
              this.setState({
                finalResetUpdate: true,
              });
            }
          });
        }
      } else {
        let obj = {
          password: CryptoJS.MD5(
            this.state.formValues.confirmPassword
          ).toString(),
          id: parseInt(this.state.id),
        };
        LoginService.setForgotPassword(obj).then((response) => {
          if (response.data && response.data.message === "success") {
            this.setState({
              finalResetUpdate: true,
            });
          }
        });
      }
    }
  };
}
export default withRouter(ResetPassword);
